<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="personalInterviewData" (change)="personalInterviewChange()"
        (submit)="personalInterviewDataSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"PERSONAL_INTERVIEW_TITLE" | translate | titlecase }}</h6>
            </div>




        </div>
        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3">
                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row justify-content-center">
                            <!-- <h5 class="font-bold m-0">{{(globals.lang == 'en')? candNameEn:candNameAr}} - {{candCode}} -
                                {{candNatId}}</h5> -->

                            <div class="img-with-text">
                                <!-- <img src="assets/images/stud-image.png" class="img-fluid" width="100" id="userImageTag"> -->
                                <img src="{{ photoPath}}" onerror="this.src ='assets/images/stud-image.png';"
                                    alt="Photo" class="img-fluid" width="100" id="userImageTag">
                                <p style="font-weight: bold;font-size: 16px">
                                    {{"CANDIDATE_NAME" | translate | titlecase}}: &nbsp; &nbsp;{{((globals.lang ==
                                    'en')? candNameEn:candNameAr)}} <br /><br />
                                    {{"CANDUDATE_CODE" | translate | titlecase}}: &nbsp; &nbsp; {{ candCode}}
                                    <br /><br />
                                    {{"NATIONAL_ID" | translate | titlecase}}: &nbsp; &nbsp;{{ candNatId}}<br /><br />
                                </p>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"INTERVIEW_DATE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="currentDate" readonly>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"INTERVIEW_RUBRIC_SCORE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="commentRubricScore">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}</option>
                                    <option value="A1" title="{{'INTERVIEW_A1_LEVEL_DESC' | translate | titlecase }}">A1
                                    </option>
                                    <option value="A2" title="{{'INTERVIEW_A2_LEVEL_DESC' | translate | titlecase }}">
                                        A2
                                    </option>
                                    <option value="B1" title="{{'INTERVIEW_B1_LEVEL_DESC' | translate | titlecase }}">
                                        B1
                                    </option>
                                    <option value="B2" title="{{'INTERVIEW_B2_LEVEL_DESC' | translate | titlecase }}">B2
                                    </option>
                                    <option value="C1" title="{{'INTERVIEW_C1_LEVEL_DESC' | translate | titlecase }}">C1
                                    </option>
                                    <option value="C2" title="{{'INTERVIEW_C2_LEVEL_DESC' | translate | titlecase }}">C2
                                    </option>
                                    <!-- <option *ngFor="let res of countries" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.countryNameAr : res.countryNameEn
                                        }}</option> -->
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.commentRubricScore.touched && personalInterviewData.controls.commentRubricScore.invalid && personalInterviewData.dirty">
                                    <!-- {{"PLEASE_SELECT_A_COUNTRY" | translate | titlecase}} -->
                                    {{"PLEASE_SELECT_INTERVIEW_RUBRIC_SCORE" | translate | titlecase }}
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"INTERVIEW_COMMENT" | translate | titlecase }}</label>
                                <input type="text" class="form-control"
                                    placeholder="{{'INTERVIEW_COMMENT' | translate | titlecase }}"
                                    formControlName="interviewComment">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.interviewComment.touched && personalInterviewData.controls.interviewComment.invalid && personalInterviewData.dirty">
                                    {{"PLEASE_ENTER_INTERVIEW_COMMENT" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"INTERVIEW_WRITING_RUBRIC_SCORE" | translate | titlecase
                                    }}</label>
                                <select class="form-control custom-select" formControlName="writingRubricScore">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}</option>
                                    <option value="A1" title="{{'INTERVIEW_A1_LEVEL_DESC' | translate | titlecase }}">A1
                                    </option>
                                    <option value="A2" title="{{'INTERVIEW_A2_LEVEL_DESC' | translate | titlecase }}">
                                        A2
                                    </option>
                                    <option value="B1" title="{{'INTERVIEW_B1_LEVEL_DESC' | translate | titlecase }}">
                                        B1
                                    </option>
                                    <option value="B2" title="{{'INTERVIEW_B2_LEVEL_DESC' | translate | titlecase }}">B2
                                    </option>
                                    <option value="C1" title="{{'INTERVIEW_C1_LEVEL_DESC' | translate | titlecase }}">C1
                                    </option>
                                    <option value="C2" title="{{'INTERVIEW_C2_LEVEL_DESC' | translate | titlecase }}">C2
                                    </option>
                                    <!-- <option *ngFor="let res of countries" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.countryNameAr : res.countryNameEn
                                        }}</option> -->
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.writingRubricScore.touched && personalInterviewData.controls.writingRubricScore.invalid && personalInterviewData.dirty">
                                    {{"PLEASE_SELECT_INTERVIEW_WRITING_RUBRIC_SCORE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"INTERVIEW_WRITING_COMMENT" | translate | titlecase
                                    }}</label>
                                <input type="text" class="form-control"
                                    placeholder="{{'INTERVIEW_WRITING_COMMENT' | translate | titlecase }}"
                                    formControlName="interviewWritingComment">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.interviewWritingComment.touched && personalInterviewData.controls.interviewWritingComment.invalid && personalInterviewData.dirty">
                                    {{"PLEASE_ENTER_INTERVIEW_WRITING_COMMENT" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ATTITUDE_RUBRIC_SCORE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="attitudeRubricScore">
                                    <option value="" [selected]="true">{{"SELECT" | translate | titlecase }}</option>
                                    <option value="Extremely Motivated to join the program">{{"EXT_MOTIVATED_TO_JOIN" |
                                        translate | titlecase }}</option>
                                    <option
                                        value="Motivated to join the program [being the only opportunity he/she has]">
                                        {{"MOTIVATED_TO_JOIN_PROGRAM" | translate | titlecase }}</option>
                                    <option value="Hesitant to join the program">{{"HESITANT_TO_JOIN" | translate |
                                        titlecase }}</option>
                                    <option value="Not motivated to join the program">{{"NOT_MOTIVATED_TO_JOIN" |
                                        translate | titlecase }}</option>
                                    <!-- <option *ngFor="let res of countries" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.countryNameAr : res.countryNameEn
                                        }}</option> -->
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.attitudeRubricScore.touched && personalInterviewData.controls.attitudeRubricScore.invalid && personalInterviewData.dirty">
                                    <!-- {{"PLEASE_SELECT_A_COUNTRY" | translate | titlecase}} -->
                                    {{"PLEASE_SELECT_ATTINTUDE_RUBRIC_SCORE" | translate | titlecase }}
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ATTINTUDE_COMMENT" | translate | titlecase }}</label>
                                <input type="text" class="form-control"
                                    placeholder="{{'ATTINTUDE_COMMENT' | translate | titlecase }}"
                                    formControlName="attitudeComment">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.attitudeComment.touched && personalInterviewData.controls.attitudeComment.invalid && personalInterviewData.dirty">
                                    {{"PLEASE_ENTER_ATTINTUDE_COMMENT" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"INTERVIEW_VIDEO_LINK" | translate | titlecase }}</label>
                                <input type="text" [(ngModel)]="link" class="form-control"
                                    placeholder="{{'INTERVIEW_VIDEO_LINK' | translate | titlecase }}"
                                    formControlName="interviewVideoLink">
                                <a class="btn btn-primary" href="{{ link }}" *ngIf="link !== null &&link.length > 0 "
                                    target="_blank" role="button">{{"OPEN" | translate | titlecase }}</a>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="personalInterviewData.controls.interviewVideoLink.touched && personalInterviewData.controls.interviewVideoLink.invalid && personalInterviewData.dirty">
                                    {{"PLEASE_ENTER_INTERVIEW_VEDIO_LINK" | translate | titlecase }}
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0"
                                    routerLink="/admission/candidate-inquiry" *ngIf="!creating">
                                    {{"CANCEL" | translate | titlecase }}</button>
                                <button type="submit" class="btn btn-primary m-2 rounded-0"
                                    *ngIf="!creating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - INTERVIEW-UPDATE')"><i
                                        class="fas fa"></i>
                                    {{"SAVE" | translate | titlecase }}</button>
                                <app-loader [show]="creating"></app-loader>
                            </div>
                        </div>




                    </div>
                </div>
            </div>
        </div>



    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>